import type { ReactNode } from "react";
import { Button, Card } from "../components/ui";
import { useOrganization } from "./OrganizationProvider";

export function RequireOrganization({ children }: { children: ReactNode }) {
  const { memberships, state, error, selectOrganization } = useOrganization();

  if (state === "loading") return <div className="public-page">Validando organização…</div>;
  if (state === "ready") return <>{children}</>;

  if (state === "selection-required") {
    return (
      <div className="public-page access-gate-page">
        <Card>
          <p className="eyebrow">SELEÇÃO DE ORGANIZAÇÃO</p>
          <h1>Escolha a organização para esta sessão</h1>
          <p>
            Seu acesso possui mais de uma organização ativa. Selecione uma antes de abrir dados
            operacionais.
          </p>
          <div className="access-gate-options">
            {memberships.map((membership) => (
              <Button
                key={membership.id}
                variant="secondary"
                onClick={() => void selectOrganization(membership.organizationId)}
              >
                {membership.organizationName}
              </Button>
            ))}
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="public-page access-gate-page">
      <Card>
        <p className="eyebrow">ACESSO RESTRITO</p>
        <h1>Não há organização ativa para esta conta</h1>
        <p>{error ?? "Peça a um administrador para revisar sua associação à organização."}</p>
      </Card>
    </div>
  );
}
